import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import Divider from "@mui/material/Divider";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FormControl from '@mui/material/FormControl';
import { Box } from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import step from "assets/theme/components/stepper/step";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const AddApplication = () => {
  const navigate = useNavigate();
  const [selectedDegree, setSelectedDegree] = useState("");
  const [selectedPostIntermediateDegree, setSelectedPostIntermediateDegree] = useState("");
  const [degreeOptions, setDegreeOptions] = useState([]);
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Fetch available campaigns when component mounts
    fetchCampaigns();
  }, []);

  useEffect(() => {
    // Update next button state based on selections
    if (!selectedCampaign) {
      setIsNextButtonDisabled(true);
      return;
    }

    if (selectedDegree === "mphil" || selectedDegree === "phd") {
      setIsNextButtonDisabled(!selectedPostIntermediateDegree);
    } else if (selectedDegree) {
      setIsNextButtonDisabled(false);
    } else {
      setIsNextButtonDisabled(true);
    }
  }, [selectedCampaign, selectedDegree, selectedPostIntermediateDegree]);

  const fetchCampaigns = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/campaign/get_campaigns`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const options = data.campaigns.map(campaign => ({
        value: campaign.id,
        label: campaign.name
      }));
      setCampaignOptions(options);

    } catch (error) {
      toast.error("An error occurred while fetching campaigns");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCampaignChange = (selected) => {
    setSelectedCampaign(selected);
    // Reset degree selections when campaign changes
    setSelectedDegree("");
    setSelectedPostIntermediateDegree("");
    setDegreeOptions([]);
  };

  const handleDegreeChange = (event) => {
    const degree = event.target.value;
    setSelectedDegree(degree);
    setSelectedPostIntermediateDegree(""); // Reset intermediate degree

    if (degree === "mphil" || degree === "phd") {
      setDegreeOptions([
        "BS/B.Sc (Hons)(4 Years)",
        "BA/B.Sc or Equivalent & M.A/M.Sc",
      ]);
    } else {
      setDegreeOptions([]); // Clear options for other degrees
    }
  };

  const handlePostIntermediateDegreeChange = (event) => {
    const value = event.target.value;
    setSelectedPostIntermediateDegree(value);
  };

  const handleStartApplication = async () => {
    if (!selectedCampaign || !selectedDegree) {
      toast.error("Please select all required fields");
      return;
    }

    let type;
    if (selectedDegree === "bs") {
      type = "Undergraduate";
    } else if (selectedDegree === "mphil" && selectedPostIntermediateDegree === "BS/B.Sc (Hons)(4 Years)") {
      type = "Postgraduate";
    } else if (selectedDegree === "phd" && selectedPostIntermediateDegree === "BS/B.Sc (Hons)(4 Years)") {
      type = "PH.D";
    } else if (selectedDegree === "bs5") {
      type = "Undergraduate-5";
    } else if (selectedDegree === "mphil" && selectedPostIntermediateDegree === "BA/B.Sc or Equivalent & M.A/M.Sc"){
      type = "Postgraduate-5"
    } else if (selectedDegree === "phd" && selectedPostIntermediateDegree === "BA/B.Sc or Equivalent & M.A/M.Sc"){
      type = "Phd-5"
    }
    
    let data = {
      application_type: type,
      campaign_id: selectedCampaign.value
    }
    
    try {
      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/application/create_application_admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const data = await response.json();
        navigate(`/bzu-application-form-admin?a=${data.application_id}&type=${type}`);
      } else {
        const error = await response.json();
        toast.error(error.error || "Failed to create application");
      }
    } catch (error) {
      toast.error("An error occurred while creating the application");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12} md={8} lg={6}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                textAlign="center"
              >
                <MDTypography variant="h6" color="white">
                  Start New Application
                </MDTypography>
              </MDBox>
              <MDBox p={3} textAlign="center">
                <Box sx={{ width: '100%', mb: 3 }}>
                  <MDTypography variant="subtitle1" fontWeight="medium" mb={1}>
                    Select Campaign
                  </MDTypography>
                  <Select
                    placeholder="Select Campaign"
                    options={campaignOptions}
                    value={selectedCampaign}
                    onChange={handleCampaignChange}
                    isLoading={isLoading}
                    className="campaign-select"
                    isClearable
                    isDisabled={isLoading}
                  />
                </Box>

                {selectedCampaign && (
                  <>
                    <Divider sx={{ my: 2 }} />
                    
                    <Box sx={{ width: '100%', mb: 3 }}>
                      <MDTypography variant="subtitle1" fontWeight="medium" mb={1}>
                        I want to Apply in:
                      </MDTypography>
                      <FormControl fullWidth>
                        <select
                          value={selectedDegree}
                          onChange={handleDegreeChange}
                          disabled={!selectedCampaign || isLoading}
                          style={{
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            width: '100%',
                            fontSize: '1rem'
                          }}
                        >
                          <option value="" disabled>Select Degree</option>
                          <option value="bs">Undergraduate</option>
                          <option value="bs5">BS 5th Semester</option>
                          <option value="mphil">M.Phil</option>
                          <option value="phd">Ph.d</option>
                        </select>
                      </FormControl>
                    </Box>

                    {(selectedDegree === "mphil" || selectedDegree === "phd") &&
                      degreeOptions.length > 0 && (
                        <Box sx={{ width: '100%', mb: 3 }}>
                          <MDTypography variant="subtitle1" fontWeight="medium" mb={1}>
                            Which degree you studied after intermediate:
                          </MDTypography>
                          <FormControl fullWidth>
                            <select
                              value={selectedPostIntermediateDegree}
                              onChange={handlePostIntermediateDegreeChange}
                              disabled={isLoading}
                              style={{
                                padding: '10px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                width: '100%',
                                fontSize: '1rem'
                              }}
                            >
                              <option value="" disabled>Select One</option>
                              {degreeOptions.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </FormControl>
                        </Box>
                      )}

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleStartApplication}
                      style={{color: "white"}}
                      disabled={isNextButtonDisabled || isLoading}
                      sx={{ mt: 2 }}
                    >
                      Start Application
                    </Button>
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ToastContainer />
    </DashboardLayout>
  );
};

export default AddApplication;